import {
	GET_MESSAGES,
	GET_MESSAGES_SUCCESS,
	GET_MESSAGES_FAIL,
	GET_MESSAGES_RESET,
} from '../actions/getMessagesAction';

const initialState = {
	apiState: '',
	message: '',
	data: null,
	error: '',
};

const getMessagesReducer = (state = initialState, action) => {
	switch (action.type) {
		case GET_MESSAGES:
			return {
				...state,
				apiState: 'loading',
			};
		case GET_MESSAGES_SUCCESS:
			return {
				...state,
				apiState: 'success',
				data: action.response.data,
				message: action.response.message
					? action.response.message
					: 'success',
			};
		case GET_MESSAGES_FAIL:
			return {
				...state,
				apiState: 'error',
				error: action.response.errors,
				message: action.response.message
					? action.response.message
					: 'error',
			};
		case GET_MESSAGES_RESET:
			return initialState;
		default:
			return state;
	}
};

export default getMessagesReducer;
